import React from "react";
import { makeStyles } from "@material-ui/styles";
import {
  renderHighlightedText,
  renderFullHighlight,
} from "../../utils/highlightHelpers";
import { useLanguage, localizedField } from "../../../contexts/LanguageContext";

const useStyles = makeStyles(() => ({
  meta_row: {
    display: "flex",
    alignItems: "center",
    columnGap: 6,
    fontSize: 11,
  },
  target_name_tag: { fontSize: 14, fontWeight: 700 },
  match_row: {
    fontSize: 11,
    color: "#666",
    marginTop: 2,
    lineHeight: 1.4,
  },
  match_highlight: {
    backgroundColor: "#ffe0e0",
    color: "#c00",
    fontWeight: 600,
    borderRadius: 2,
  },
}));

function SearchResultOption({ option }) {
  const classes = useStyles();
  const { language } = useLanguage();

  // optionがFuse結果（{item, matches}）か通常のアイテムかを判定
  const item = option.item ?? option;
  const matches = option.matches ?? [];

  const hasEnValue = (baseKey) => {
    const value = item?.[`${baseKey}_en`];
    return value !== undefined && value !== null && value !== "";
  };

  // 指定されたbaseKeyに対して、言語に応じたマッチを取得する
  const getMatch = (baseKey) => {
    if (language === "en" && hasEnValue(baseKey)) {
      return matches.find((m) => m.key === `${baseKey}_en`);
    }
    return matches.find((m) => m.key === baseKey);
  };

  // 言語に応じた表示名
  const displayTargetName = localizedField(item, "target_name", language);
  const displayAreaName = localizedField(item, "area_name", language);
  const displayBuildingName = localizedField(item, "building_name", language);
  const displayFloorName = localizedField(item, "floor_name", language);
  const displayDescription = localizedField(item, "description", language);
  const displayPropertiesText = localizedField(item, "properties_text", language);

  // 各フィールドのマッチを探す
  const targetNameMatch = getMatch("target_name");
  const areaNameMatch = getMatch("area_name");
  const buildingNameMatch = getMatch("building_name");
  const floorNameMatch = getMatch("floor_name");
  const descMatch = getMatch("description");
  const propsMatch = getMatch("properties_text");

  return (
    <div>
      <span className={classes.target_name_tag}>
        {renderFullHighlight(
          displayTargetName,
          targetNameMatch,
          classes.match_highlight,
        )}
      </span>
      <br />
      <div className={classes.meta_row}>
        {displayAreaName && (
          <span>
            {renderFullHighlight(
              displayAreaName,
              areaNameMatch,
              classes.match_highlight,
            )}
          </span>
        )}
        {item.building_code && <span>{item.building_code}</span>}
        {displayBuildingName && (
          <span>
            {renderFullHighlight(
              displayBuildingName,
              buildingNameMatch,
              classes.match_highlight,
            )}
          </span>
        )}
        {displayFloorName && (
          <span>
            {renderFullHighlight(
              displayFloorName,
              floorNameMatch,
              classes.match_highlight,
            )}
          </span>
        )}
      </div>
      {descMatch && descMatch.indices?.length > 0 && (
        <div className={classes.match_row}>
          {renderHighlightedText(
            displayDescription,
            descMatch.indices,
            classes.match_highlight,
          )}
        </div>
      )}
      {propsMatch && propsMatch.indices?.length > 0 && (
        <div className={classes.match_row}>
          {renderHighlightedText(
            displayPropertiesText,
            propsMatch.indices,
            classes.match_highlight,
          )}
        </div>
      )}
    </div>
  );
}

export default React.memo(SearchResultOption);
